import { EntidadeBase } from 'hay-core-react';

class ModalidadeModel extends EntidadeBase {
  constructor() {
    super('modalidade');
  }
}

export default new ModalidadeModel();
